import request from '@/utils/request'

export function fetchDeviceList(query) {
  return request({
    url: '/api/device/list',
    method: 'get',
    params: query
  })
}
export function changeMode(data) {
  return request({
    url: '/api/device/changemode',
    method: 'post',
    data
  })
}
export function fetchDevice(query) {
  return request({
    url: '/api/device/detail',
    method: 'post',
    params: query
  })
}
export function fetchLatestDeviceGps(query) {
  return request({
    url: '/api/device/getLatestDeviceGps',
    method: 'get',
    params: query
  })
}

